import { LockKeyhole, EyeOff, Eye } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";

const MODES = [
  {
    id: "blind",
    Icon: EyeOff,
    lead: "Modalità Blind (Anonimato Totale):",
    text: "L'azienda valuta esclusivamente la tua mente. Nessun dato personale viene condiviso. Se un'azienda decide di sbloccare il tuo profilo, le comunicazioni avverranno in modo protetto e schermato tramite l'infrastruttura di Prodigy, salvaguardando la tua identità.",
  },
  {
    id: "chiaro",
    Icon: Eye,
    lead: "Modalità in Chiaro:",
    text: "Scegli di essere visibile da subito. Le aziende che sbloccheranno il tuo profilo avranno accesso ai tuoi contatti diretti (nome, cognome, email, telefono), esattamente come su un curriculum tradizionale.",
  },
];

export const ControlloAssoluto = () => (
  <section
    className="relative w-full px-6 py-28 lg:py-52 border-y border-[#121316] bg-[#040405]/90"
    data-testid="zero-bias-section"
  >
    <Reveal variant="tech" className="max-w-[960px] mx-auto text-center">
      <div className="flex items-center justify-center gap-3 mb-8">
        <LockKeyhole className="h-4 w-4 text-cyan" strokeWidth={1.6} />
        <Eyebrow>Controllo Assoluto</Eyebrow>
      </div>
      <h2 className="font-extrabold tracking-[-0.045em] leading-[1.02] text-4xl sm:text-6xl lg:text-7xl" data-testid="zero-bias-title">
        La privacy la decidi tu.
      </h2>
      <span className="tech-line tech-line-center mt-10" />
      <p className="mt-10 mx-auto max-w-[64ch] text-lg sm:text-xl lg:text-[1.3rem] leading-[1.8] font-light text-titanium" data-testid="zero-bias-text">
        Sbloccando il test attitudinale e l'analisi AI, il tuo profilo entra automaticamente nel{" "}
        <strong className="font-semibold text-white">Pool Premium</strong>. Ma il controllo sui tuoi dati resta{" "}
        <strong className="font-semibold text-white">esclusivamente tuo</strong>. Sei tu a decidere come presentarti al mercato:
      </p>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 text-left">
        {MODES.map(({ id, Icon, lead, text }) => (
          <article key={id} className="glass glass-light rounded-[24px] p-7 sm:p-9" data-testid={`privacy-mode-${id}`}>
            <Icon className="h-5 w-5 text-cyan" strokeWidth={1.5} />
            <p className="mt-6 text-base sm:text-lg leading-[1.75] text-titanium">
              <strong className="block mb-2 font-bold text-white text-lg sm:text-xl tracking-[-0.015em]">{lead}</strong>
              {text}
            </p>
          </article>
        ))}
      </div>
      <p className="mt-14 font-bold tracking-[-0.02em] text-white text-xl sm:text-2xl" data-testid="zero-bias-closing">
        Il potere è nelle tue mani.
      </p>
    </Reveal>
  </section>
);
